module.exports = __webpack_public_path__ + "img/composite2.8a936e5f.png";